export enum UserRoles {
  SUPPLIER = "supplier",
  PURCHASING_OPERATOR = "purchasing_operator",
  ADMIN = "admin",
  DEACTIVATED = "deactivated",
}
